import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: 63vh;
    font-family: Roboto;
    // margin-bottom: 5px;

    .action-menu {
        overflow: visible;
        border-bottom: none;
        // line-height: 33px;
        border-color: #ccc;
        display: flex;
        align-items: center;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-react-container {
        text-align: center;
    }

    .ag-header {
        background-color: #133366;
        // background-color:  #ddd;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        // font-weight: bold;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
    }

    .ag-header-cell > .ag-react-container .customHeaderLabel {
        color: #fff;
    }

    .ag-floating-top {
        overflow-y: scroll !important;
    }
    
    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        /* overflow-y: scroll !important; */
    }

    .ag-center-cols-viewport {
        // overflow-x: hidden;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .ag-cell {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        // line-height: 36px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .edit-cell {
        border-bottom: none;
        text-align: center;
        border-color: #ccc;
        width: 100%;
    }

    .edit-cell > .ag-cell-wrapper {
        width: 100%;
    }

    .edit-cell > .ag-cell-wrapper > .ag-cell-value {
        width: 100%;
    }

    span.label {
        line-height: 28px;
        font-size: 85%;
    }

    .list-cell-note {
        border-bottom: none;
        text-align: center;
        // line-height: 36px;
        border-color: #ccc;
        // font-size: 12px;
        background-color: lightgoldenrodyellow;
    }

    .list-cell-small {
        border-bottom: none;
        text-align: center;
        line-height: initial;
        border-color: #ccc;
    }

    .list-cell-full {
        border-bottom: none;
        text-align: center;
        // line-height: 26px;
        border-color: #ccc;
        // font-size: 12px;
    }

    // .list-cell-full > .ag-cell-wrapper > .ag-cell-value {
    //     height: 30px;
    // }

    .list-cell-full > .ag-react-container,
    .list-cell-full > .ag-cell-wrapper,
    .list-cell-full > .ag-cell-wrapper > .ag-cell-value {
        width: 100%;
    }

    .list-other-cell {
        background-color: #DBDBDB;
        color: black;
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #B7B7B7;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
    }

    .list-header-select-all {
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: #eee;
        border-width: 1px 1px 0px 1px;
        border-style: solid;
    }

    .list-header-select-all > .ag-react-container {
        line-height: 0px;
        padding-top: 3px;
    }

    .th-recipient-top {
        background-color: #2D6CA2;
        color: #FFF;
        border-right: 1px solid white;
    }

    .th-donor-top {
        background-color: #2D6CA2;
        color: #FFF;
    }

    .th-recipient {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
        font-weight: bold;
    }

    .th-donor {
        background-color: #ddd;
        border-color: white white #ddd white;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
        padding: 0.7rem 0.5rem !important;
        height: 32px;
        font-weight: bold;
    }

    .list-header > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-row > .ag-header-group-cell > .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

            // .totals {
            //     font-weight: 600;
            //     background-color: #ddd;
            // }

            .react-grid-Row:hover .react-grid-Cell, .react-grid-Row.row-context-menu .react-grid-Cell {
                background-color: lightgoldenrodyellow;
            }

    .ag-icon.ag-icon-asc {
        color: white;
    }

    .ag-icon.ag-icon-desc {
        color: white;
    }

    // .customHeaderLabel {
    //     margin-left: 5px;
    //     float: left;
    //     text-align: center;
    // }

    .customSortDownLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortUpLabel {
        // float: left;
        margin-left: 3px;
    }

    .customSortRemoveLabel {
        float: left;
        font-size: 11px;
        margin-left: 3px;
    }

    .active {
        color: cornflowerblue;
    }

    select.review-type {
        padding: 2px 5px;
        height: 24px;
        // line-height: 24px;
    }
`;